import React from "react";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

export default function WhoWeHelpLinks({ isUniversity }: { isUniversity: boolean }) {
  const { t } = useTranslation();

  const items = [
    {
      title: t("Students"),
      icon: "users",
      to: "/who-we-help?students=1",
      active: !isUniversity,
    },
    {
      title: t("Universities"),
      icon: "building",
      to: "/who-we-help?universities=1",
      active: isUniversity,
    },
  ];

  return (
    <div className="who-we-help-links d-center gap-2 mx-auto">
      {items.map((item, index) => (
        <BaseButton
          key={index}
          className={"who-we-help-links__button px-3" + (item.active ? " __active fw-bold" : "")}
          gradient={item.active}
          borderless={!item.active}
          large
          to={item.to}
        >
          <BaseIcon className="f-shrink-0 mr-2">{item.icon}</BaseIcon>
          {item.title}
        </BaseButton>
      ))}
    </div>
  );
}
